import { observable, action } from "mobx";
import { DateHelper } from '../helpers/DateHelper';

let dateHelper = new DateHelper();

class DateRangeStore {
        @observable start_date = localStorage.getItem('start_date') || dateHelper.date().startOf('year').subtract(12, "months").format("MM/DD/YYYY"); 
        @observable end_date = localStorage.getItem('end_date') || dateHelper.date().endOf('year').subtract(12, "months").format("MM/DD/YYYY");
        @observable predefined_date = "";
        

        @action setRange = (range) => {
                localStorage.setItem("start_date", dateHelper.date(range.start_date).format('MM/DD/YYYY'));
                localStorage.setItem("end_date", dateHelper.date(range.end_date).format('MM/DD/YYYY'));
                this.start_date = dateHelper.date(range.start_date).format('MM/DD/YYYY')
                this.end_date = dateHelper.date(range.end_date).format('MM/DD/YYYY')

        }
        @action setPredefined_Date = (value) => {
                localStorage.setItem('pre_defined_range_label', value)
               this.predefined_date=value;
            }
        @action setall_data = (range) => {
                this.start_date = dateHelper.date(range.start_date).format('MM/DD/YYYY')
                this.end_date = dateHelper.date(range.end_date).format('MM/DD/YYYY')
        }
}

export default DateRangeStore;
